import { Link } from 'react-router-dom';
import { Flag } from 'lucide-react';
import WidgetCard from '../components/WidgetCard';
import { MilestoneMeasure, MilestoneState, usePlanMetrics, usePlans } from '../components/PlanCard';
import { formatDueDate } from '../components/TaskCard';
import type { WidgetProps } from './types';

const DEFAULT_LIMIT = 3;

// The business's active plans, with how far each milestone has got.
export default function PlansWidget({ config }: WidgetProps<{ limit?: number }>) {
  const { plans } = usePlans('active');
  const metrics = usePlanMetrics();

  if (!plans || plans.length === 0) return null;
  const byId = Object.fromEntries((metrics?.metrics ?? []).map(m => [m.id, m]));

  return (
    <WidgetCard
      title="Plans"
      icon={Flag}
      action={<Link to="/plans" className="text-[12px] text-brand-dark hover:underline">See the plans</Link>}
    >
      <div className="space-y-4">
        {plans.slice(0, config.limit ?? DEFAULT_LIMIT).map(plan => (
          <div key={plan.id}>
            <p className="text-[13px] font-semibold text-graphite">
              {plan.name} <span className="font-normal text-coolslate">· due {formatDueDate(plan.due_on)}</span>
            </p>
            <ul className="mt-1 space-y-2">
              {plan.milestones.map(m => (
                <li key={m.id}>
                  <div className="flex items-baseline justify-between gap-2">
                    <span className="text-[13px] text-graphite truncate">{m.name}</span>
                    <MilestoneState state={m.state} />
                  </div>
                  <MilestoneMeasure milestone={m} metric={m.concept ? byId[m.concept] : undefined} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </WidgetCard>
  );
}
